<template>
  <div class="my-page-subscription-seller mt-5">
    <p class="introtext">Forvalter du leieforhold på Husleie.no får du disse fordelene:</p>
    <div class="item">
      <i class="budicon budicon-house"></i>
      <div class="mt-3">Inntektssikring</div>
    </div>
    <div class="item">
      <i class="budicon budicon-security-guard"></i>
      <div class="mt-3">Risikoreduksjon</div>
    </div>
    <div class="item">
      <i class="budicon budicon-bubble-chart"></i>
      <div class="mt-3">Full kontroll og oversikt</div>
    </div>
    <div class="item">
      <i class="budicon budicon-shared-user"></i>
      <div class="mt-3">Hjelp hvis noe går galt</div>
    </div>
    <div class="buttons mt-4">
      <hl-Button @click="$emit('click:showMore')">Klikk for å se hva mer du får</hl-Button>
    </div>
  </div>
</template>

<script>
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';

export default {
  name: 'MyPageSubscriptionSeller',

  components: {
    'hl-Button': Button,
  },
};
</script>

<style scoped lang="scss">
.my-page-subscription-seller {
  display: grid;
  gap: 1.25rem;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  align-items: center;
  grid-template-rows: auto;

  i {
    font-size: 3rem;
    color: var(--primary);
  }

  text-align: center;
}

.buttons {
  padding-top: 1.25rem;
  grid-column: 1 / -1;
}

.introtext {
  grid-column: 1 / -1;
  font-size: 1rem;
}
</style>
